import React from 'react'
import { FormattedMessage } from 'react-intl'

import Price from 'client/components/Price'
import messages from './messages'
import type { IBoard } from 'client/components/Rooms/Rooms'
import styles from './styles.module.css'

export interface IRoomsSelector {
  roomsSelected: IBoard[]
  showNightNetPrice: boolean
  currency: string
}

const RoomsSelector = ({ roomsSelected = [], currency, showNightNetPrice }: IRoomsSelector) => {
  const selectedRoomsCount = { total: roomsSelected.length }
  const totalPrice = roomsSelected.reduce(
    (total, room) => total + (showNightNetPrice ? room.finalPrice : room.totalWithFees || 0),
    0
  )

  return (
    <div className={styles.roomsSelector}>
      <div className={styles.selectorInner}>
        <FormattedMessage
          {...messages.selectedRoomsTitle}
          values={selectedRoomsCount}
          tagName="p"
        />

        <ul>
          {roomsSelected.map(room => (
            <li
              className={`${styles.roomsSelectorList} ${styles.roomsSelected}`}
              key={room.availabilityId}
              data-testid="room-selected"
            >
              <p>1 x {room.roomName}</p>
              <Price
                amount={Math.round(showNightNetPrice ? room.finalPrice : room.totalWithFees)}
                currency={currency}
              />
            </li>
          ))}

          {roomsSelected.length > 0 && (
            <li className={`${styles.roomsSelectorList} ${styles.total}`}>
              <FormattedMessage {...messages.total} tagName="p" />
              <Price amount={Math.round(totalPrice)} currency={currency} />
            </li>
          )}
        </ul>
      </div>
    </div>
  )
}

export default RoomsSelector
